<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Shared"
    seFeDataSubtitle="Shared libraries"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Shared contain libraries meant for use across multiple apps and/or libraries.</p>
        <p>To run and view this library locally, checkout the repo then run</p>
        <se-fe-docs-code [code]="code.setup"></se-fe-docs-code>
        <p>then to run against staging, run</p>
        <se-fe-docs-code [code]="code.start"></se-fe-docs-code>
        <p>to run against local services, run</p>
        <se-fe-docs-code [code]="code.startDev"></se-fe-docs-code>
        <p>Then navigate to</p>
        <p><a href="https://people-and-orgs.ui.sportngin.com.dev/docs/#/shared">https://people-and-orgs.ui.sportngin.com.dev/docs/#/shared</a></p>
        <p>Look under the left nav shared submenu to view the ui and feature docs.</p>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
